module.exports = __webpack_public_path__ + "img/bg-shippo-s.8ede112a.svg";